export const showRecaptchaBadge = () => {
  document.body.classList.add('show-recaptcha-badge');
};

export const hideRecaptchaBadge = () => {
  document.body.classList.remove('show-recaptcha-badge');
};
